import decode from 'jwt-decode';

export interface DecodedToken {
  exp?: number;
  [key: string]: unknown;
}

export const decodeToken = (token: string | null): DecodedToken | null => {
  if (!token) return null;

  try {
    return decode(token) as DecodedToken;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const isTokenExpired = (exp: number): boolean => {
  const now = Date.now();
  return now > exp * 1000;
};

export const isAccessTokenValid = (accessToken: string | null): boolean => {
  const decoded = decodeToken(accessToken);

  if (!decoded?.exp) {
    return false;
  }

  return !isTokenExpired(decoded.exp);
};

export const isIdTokenExpired = (idToken: string | null): boolean => {
  const decoded = decodeToken(idToken);

  if (!decoded?.exp) {
    return false;
  }

  return isTokenExpired(decoded.exp);
};
